const baseUrl = 'https://pmrfnapp-bffapi-dev.azurewebsites.net';

export const environment = {
  production: false,
  apiEndpoint: baseUrl,
  getManufacturersOptionsDataURL: baseUrl + "/api/v1/jobmanager/fetchmanufacturers",
  typeDesignationsOptionsDataURL: baseUrl + "/api/v1/jobmanager/fetchtypedesignations",
  getObjectTypeOptionsURL: baseUrl + '/api/v1/jobmanager/fetchobjecttype',
  fetchNewMRDataURL: baseUrl + '/api/v1/jobmanager/fetch',
  saveDraftDataAPI: baseUrl + '/api/v1/jobmanager/savedraft',
  fetchMySavedMRDataURL: baseUrl + '/api/v1/jobmanager/fetchsavedwtt',
  editMRRecordWorkLIstURL: baseUrl + '/api/v1/jobmanager/fetchWI',
  getFetchPMActionsURL: baseUrl + '/api/v1/jobmanager/fetchpmactions',
  saveMySavedWTTURL: baseUrl + '/api/v1/jobmanager/SaveWI',
  downloadTSMURL: baseUrl + '/api/v1/jobmanager/downloadtsm',
  isassetdetailsset: baseUrl + '/api/v1/jobmanager/isassetdetailsset',
  issplitpossible: baseUrl + '/api/v1/jobmanager/issplitpossible',
  fetchCheckBoxDeatilsURL: baseUrl + '/api/v1/jobmanager/fetchclubbedwi',
  splitwiURL: baseUrl + '/api/v1/jobmanager/splitwi',
  resplitwi: baseUrl + '/api/v1/jobmanager/resplitwi',
  fetchWorkListDetails: baseUrl + '/api/v1/jobmanager/fetchWorkListDetails',
  saveworklistdata: baseUrl + '/api/v1/jobmanager/saveworklistdata',
  fetchassetdetails: baseUrl + '/api/v1/jobmanager/fetchassetdetails',
  updateassetdetails: baseUrl + '/api/v1/jobmanager/updateassetdetails',
  ValidateToken: baseUrl + '/api/v1/jobmanager/login',
  msalConfig: {
    auth: {
      clientId: '96ee9392-19d3-432d-933e-fa81f1a5083a',
      authority: 'https://login.microsoftonline.com/05d75c05-fa1a-42e7-9cf1-eb416c396f2d'
    }
  },
  apiConfig: {
    scopes: ['api://96ee9392-19d3-432d-933e-fa81f1a5083a/Access'],
    uri: 'https://graph.microsoft.com/v1.0/me'
  }

}

